import OrganizationServer from "@/api/organization";

export default {
    namespaced: true,
    state: {
        loading: false,
        page: {
            total: 0,
            records: []
        },
        pageSearch: {
            current: 1,
            size: 10,
            search: {
                source: 0,
                status: true,
                role_id: null,
                like_code: null,
                like_name: null,
                like_model_name: null,
            }
        }
    },
    getters: {
        /**
         * @return {null}
         */
        ['RolePermissionBackendListGetPageSearchSearchRoleId'](state) {
            return state.pageSearch.search.role_id;
        },
        ['RolePermissionBackendListGetPageSearch'](state) {
            return state.pageSearch;
        },
        ['RolePermissionBackendListGetPageCurrent'](state) {
            return state.pageSearch.current;
        },
        ['RolePermissionBackendListGetPageSize'](state) {
            return state.pageSearch.size;
        },
        ['RolePermissionBackendListGetPageTotal'](state) {
            return state.page.total;
        },
    },
    mutations: {
        ['RolePermissionBackendListSetLoading'](state, loading) {
            state.loading = loading;
        },
        ['RolePermissionBackendListSetPage'](state, page) {
            state.page = page;
        },
        ['RolePermissionBackendListSetPageSearch'](state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        ['RolePermissionBackendListSetPageSearchSearch'](state, pageSearchSearch) {
            state.pageSearch.search = pageSearchSearch;
        },
        ['RolePermissionBackendListSetPageSearchSearchRoleId'](state, roleId) {
            state.pageSearch.search.role_id = roleId;
        },
        ['RolePermissionBackendListSetPageCurrent'](state, pageCurrent) {
            state.pageSearch.current = pageCurrent;
        },
        ['RolePermissionBackendListSetPageSize'](state, pageSize) {
            state.pageSearch.size = pageSize;
        }
    },
    actions: {
        async queryByPage({commit}, params) {
            commit('RolePermissionBackendListSetLoading', true);
            commit('RolePermissionBackendListSetPageSearch', params);
            try {
                let result = await OrganizationServer.rolePermission.page(params);
                if (result.data.code === '200') {
                    let records = result.data.data.records;
                    records.forEach(
                        p => {
                            //切分角色
                            let temp = p.extendRoleName.split(",");
                            let roles = [];
                            let index = 0;
                            temp.forEach(
                                r => {
                                    let rArr = r.split('@ATHUB@');
                                    roles.push({
                                        index: ++index,
                                        id: rArr[0],
                                        name: rArr[1]
                                    })
                                }
                            );
                            p.extendRoleName = roles;
                        }
                    );
                    result.data.data.records = records;
                    commit('RolePermissionBackendListSetPage', result.data.data);
                }
                commit('RolePermissionBackendListSetLoading', false);
            } catch (e) {
                console.log(e.message);
                commit('RolePermissionBackendListSetLoading', false);
                throw e;
            }
        }
    }
}
